export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Greek-212f02d0602fdc28b815bc5fc43ecc89.woff";